export default {"LABEL":"Border-Bottom Rules 下边框规则","DESC":"下边框填充配色规则","COMPONENTS":{"__markdown":true}}